import { AuthService } from "./Auth/AuthService";


export class Agent
{
    public Id: string;
    public IsActive: boolean;
    public Icon: string;
    public Name: string;
    public Phone: string;

    public get AsString(): string
    {
        return this.Icon + " " + this.Name;
    }

    public get NameAndPhone(): string
    {
        return this.Name + ", tel: " + this.Phone;
    }

    constructor(id: string, icon: string, name: string, phone: string, isActive: boolean = true)
    {
        this.Id = id;
        this.IsActive = isActive;
        this.Icon = icon;
        this.Name = name;
        this.Phone = phone;
    }

    public static get Default(): Agent
    {
        return new Agent("tB", "🐓", "Tomasz", "507-293-714", true);
    }
}

export class AgentsProvider
{
    private agents = [
        Agent.Default,
        new Agent("kK", "🐭", "Kasia", "534-690-600", true),
        new Agent("kT", "🍆", "Kiryl", "501-521-500", false),
        new Agent("iS", "🍄", "Igor", "724-182-856", false),
    ]

    constructor(private _auth: AuthService)
    { }

    public IsItMe(id: string): boolean
    {
        return this._auth.UserInfo?.User?.Id === id;
    }

    public get All(): Agent[]
    {
        return this.agents;
    }

    public Get(id: string): Agent | undefined
    {
        return this.agents.find(x => x.Id === id);
    }
}
